import CoverableDetailsTemplate from '../../../../templates/CoverableDetailsTemplate';
import WizardPagetemplate from '../../../../templates/WizardPagetemplate';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { useHippoText } from '../../../../hooks/useHippoText';
import { NumberField } from '@flos/react-ui';
import ViewInformationModal from '../../../../shared_components/ViewInformationModal/ViewInformationModal';
import { useState } from 'react';
import { useUpdateCoverableInformation } from '../../../../recoil/hooks/useUpdateCoverableInformation';
import { useSaveCoverableInformation } from '../../../../hooks/useSaveCoverableInformation';
import type { CoverableInformationToUpdateDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa';
import { track } from '../../../../utils/trackingUtil';
import HelpLink from '../../../../shared_components/HelpLink/HelpLink';

const ContentAgeOfOldestInHouseholdStep = ({
    goNext,
    goPrevious
}: {
    goNext: () => void;
    goPrevious: () => void;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [coverables] = useRecoilState(allCoverablesOnsaAtom);
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const { saveCoverableInformation } = useSaveCoverableInformation();
    const contentCoverables = coverables.privateContent ?? [];
    const coverableIndex = contentCoverables?.findIndex(
        (coverable) => coverable.fixedId === currentProduct.fixedId
    );
    const currentContentCoverable = contentCoverables[coverableIndex];
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [age, setAge] = useState<number>();

    const viewInformationModalContent = {
        title: getHippoText('DSS-CON -HIGHLIGHTED-TEXT-MODAL-BIRTHDAY-PRC-HEADER'),
        description: getHippoText('DSS-CON -HIGHLIGHTED-TEXT-MODAL-BIRTHDAY-PRC')
    };

    const onNext = (): void => {
        setIsLoading(true);
        const updatedCoverable: CoverableInformationToUpdateDTO = {
            privateContent: {
                publicId: currentContentCoverable.publicId,
                fixedId: currentContentCoverable.fixedId,
                ageOfOldestInHousehold: currentContentCoverable.ageOfOldestInHousehold
            },
            productToUpdate: currentProduct.flavourName
        };

        void saveCoverableInformation(updatedCoverable).then(() => {
            setIsLoading(false);
            track(`${currentProduct.flavourName}CoverableInformationAgeOfOldestInHousehold`, [
                {
                    ageOfOldestInHousehold: currentContentCoverable.ageOfOldestInHousehold
                }
            ]);
            goNext();
        });
    };

    return (
        <WizardPagetemplate
            onNext={onNext}
            onPrevious={goPrevious}
            disableNext={isLoading || !currentContentCoverable.ageOfOldestInHousehold}
            isNextLoading={isLoading}
            disablePrevious={isLoading}
        >
            <CoverableDetailsTemplate
                header={getHippoText('DSS-COVERABLE-INFORMATION-STEP-AGE-HEADER')}
            >
                <NumberField
                    label={getHippoText('DSS-COVERABLE-INFORMATION-STEP- AGE-INPUTFIELD')}
                    value={
                        !currentContentCoverable.ageOfOldestInHousehold
                            ? age?.toString()
                            : currentContentCoverable.ageOfOldestInHousehold.toString()
                    }
                    onChange={(event) => {
                        setAge(parseInt(event.target.value));
                    }}
                    onBlur={(event): void => {
                        updateCoverableInformation({
                            ageOfOldestInHousehold: parseInt(event.target.value)
                        });
                    }}
                    minLength={1}
                    disabled={isLoading}
                />
                <HelpLink
                    onClick={() => {
                        setShowModal(true);
                    }}
                >
                    {getHippoText('DSS-COVERABLE-INFORMATION-STEP- AGE-WHY-DO-YOU-ASK')}
                </HelpLink>
            </CoverableDetailsTemplate>
            {showModal && (
                <ViewInformationModal
                    showModal={showModal}
                    modalProps={viewInformationModalContent}
                    closeModal={() => {
                        setShowModal(false);
                    }}
                />
            )}
        </WizardPagetemplate>
    );
};

export default ContentAgeOfOldestInHouseholdStep;
